import React from 'react';

export default function AppLayout({ children }) {
  return (
    <div className="h-[100dvh] bg-[#FFFDF5] w-full flex justify-center overflow-hidden">
      <div className="w-full max-w-[480px] bg-surface relative h-[100dvh] flex flex-col shadow-2xl">
        {children}
      </div>
    </div>
  );
}
